import { useMemo } from 'react'
import { useGetIntegrationEntitiesQuery } from '../../../store/integrations/integrations'
import { useGetMeQuery } from '../../../store/user/user'
import { IntegrationServiceId } from '../../../common/integrations'
import { EventTypeAccess } from '../../../models/Scheduling'
import { type RedtailOption } from './eventConfig'

const toRedtailOptions = (list?: { id: number; name: string }[]): RedtailOption[] =>
  (list ?? []).map((e) => ({ id: e.id.toString(), label: e.name })).sort((a, b) => a.label.localeCompare(b.label))

export type RedtailEventTypeAccess = { enabled: true; redtailAccountId: string } | { enabled: false; redtailAccountId?: undefined }

export const useRedtailEventTypeAccess = (accountId: string, access: EventTypeAccess): RedtailEventTypeAccess => {
  const isAccountEventType = access === EventTypeAccess.ACCOUNT
  const { data: me } = useGetMeQuery({ accountId }, { skip: !isAccountEventType })
  const redtailAccountId = me?.integrations?.find((i) => i.serviceId === IntegrationServiceId.REDTAIL)?.externalAccountId
  return isAccountEventType && redtailAccountId ? { enabled: true, redtailAccountId } : { enabled: false }
}

export const useRedtailEntityOptions = (accountId: string, enabled: boolean) => {
  const { data: activityCodesData } = useGetIntegrationEntitiesQuery(
    { accountId, connector: IntegrationServiceId.REDTAIL, entityType: 'activity_codes' },
    { skip: !enabled },
  )
  const { data: categoriesData } = useGetIntegrationEntitiesQuery(
    { accountId, connector: IntegrationServiceId.REDTAIL, entityType: 'categories' },
    { skip: !enabled },
  )

  const activityCodeOptions = useMemo(() => toRedtailOptions(activityCodesData?.data?.activityCodes), [activityCodesData])
  const categoryOptions = useMemo(() => toRedtailOptions(categoriesData?.data?.categories), [categoriesData])

  return { activityCodeOptions, categoryOptions }
}
